import React, { type FunctionComponent } from 'react'
import { useTrackEvent } from 'utils/events/hooks'
import AppFrame from 'legacy/components/AppFrame/AppFrame'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { GeneratedReportsListBreadcrumbs } from 'legacy/sections/generated-reports/components/breadcrumbs/components/GeneratedReportsListBreadcrumbs'
import { GeneratedReportsListBody } from 'legacy/sections/generated-reports/components/list/components/GeneratedReportsListBody'
import { useListReportRequests } from 'legacy/sections/generated-reports/graphql/list.hooks'
import { useReportViewDownloads } from 'legacy/sections/generated-reports/graphql/reportViewDownloadUrl.hooks'

export const GeneratedReportsList: FunctionComponent = () => {
  useTrackEvent({ id: 'generated_reports.viewed', description: 'Viewed list of generated reports' })
  const { totalCount, called, ...rest } = useListReportRequests()
  const { downloadReportView } = useReportViewDownloads()

  return (
    <AppFrame data-testid="generated-reports-list">
      <DocumentTitle titleId="generatedReports.title" />
      <AppFrame.Header title={<GeneratedReportsListBreadcrumbs />} />
      <AppFrame.ContentBody>
        <GeneratedReportsListBody
          downloadReportView={downloadReportView}
          totalCount={totalCount}
          called={called}
          {...rest}
        />
      </AppFrame.ContentBody>
    </AppFrame>
  )
}
